export const Alert = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3062 14.5002H1.69381C0.932624 14.5002 0.450521 13.6837 0.818234 13.0172L7.12441 1.58724C7.50467 0.898006 8.4953 0.898004 8.87556 1.58723L15.1817 13.0172C15.5494 13.6837 15.0673 14.5002 14.3062 14.5002ZM7.99998 4.25025C8.4142 4.25025 8.74998 4.58604 8.74998 5.00025V9.50025C8.74998 9.91446 8.4142 10.2502 7.99998 10.2502C7.58577 10.2502 7.24998 9.91446 7.24998 9.50025V5.00025C7.24998 4.58604 7.58577 4.25025 7.99998 4.25025ZM8.74998 12.2502C8.74998 12.6645 8.4142 13.0002 7.99998 13.0002C7.58577 13.0002 7.24998 12.6645 7.24998 12.2502C7.24998 11.836 7.58577 11.5002 7.99998 11.5002C8.4142 11.5002 8.74998 11.836 8.74998 12.2502Z"
      fill="#E5352B"
    />
  </svg>
)
